import API from "@aws-amplify/api";

/**
 * Sends a support email to customer support from /account/support page
 *
 * @param {accessToken}: string
 * @param {productType}: string buildbox2 or buildbox3
 * @param {subject}: string
 * @param {message}: string
 */

export const sendSupportEmail = ({
  accessToken,
  productType,
  subject,
  message,
}: {accessToken: any, productType: string, subject:string, message:string }) => {
  return new Promise((resolve, reject) => {
    API.post("userAccountManagementURL", "/emailers/support", {
      body: {
        app: productType,
        subject: subject,
        message: message,
      },
      headers: {
        "Content-Type": "application/json",
        Token: accessToken,
      },
      response: true,
    })
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          resolve(res.data);
        }
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response);
        }
      });
  });
};

export const sendWelcomeEmail = (
  email:string,
) => {
  return new Promise((resolve, reject) => {
    API.get("userAccountManagementURL", `/emailers/download/${email}`, {
      headers: {
        "Content-Type": "application/json",
      },
      response: true,
    })
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          resolve(res.data);
        }
      })
      .catch((error) => {
        if (error.response) {
          reject(error.response);
        }
      });
  });
};

